<template>
  <section class="PaymentMethodDeleteModal">
    <section class="flex justify-content space-between mt-5 pt-5">
      <h3 class="form-wrapper-body-title">Delete Payment Method</h3>
      <p class="PaymentMethodDeleteModal__warning">
        Are you sure you want to delete this payment method?
      </p>
    </section>

    <footer class="form-wrapper-footer">

        <button
          @click="cancle"
          :class="['form-wrapper-footer-button', 'danger-btn']"
          :style="{ width: '40%',marginRight: '1rem'}"
                v-spinner="isDeletingProcessing"
        >
          Delete
        </button>
     
     
        <button
          @click="back"
          :class="[
            'form-wrapper-footer-button',
            'primary-btn',
            false && 'ie-spinner',
          ]"
          :style="{ width: '40%' }"
        >
          Back
        </button>
     
    </footer>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const SelectPaymentCardModal = () =>
  import(
    /* webpackChunkName: "activities" */ "@/components/modals/SelectPaymentCardModal"
  );

export default {
  name: "PaymentMethodDeleteModal",
  data() {
    return {
      isDeletingProcessing: false
    };
  },
  computed: {
    ...mapGetters([
      "options",
    ]),
  },
  methods: {
    ...mapActions([
      "openModal",
      "closeModal",
      "toggleFade",
      "deletePaymentMethod",
      "showSpinner"
    ]),
    async cancle() {
      this.isDeletingProcessing = true;
      this.showSpinner(true);
      await this.deletePaymentMethod(this.options.deletePaymentMethodId);
      this.isDeletingProcessing = false;
      this.showSpinner(false);
      await this.back();
    },
    async back() {
      await this.closeModal({
        dangerClose: true,
      });
      await this.toggleFade(false);
      await this.openModal({
        modal: SelectPaymentCardModal,
        options: {
          confirmOnClose: true,
        },
      });
    },
  },
  async mounted() {
    await this.toggleFade(true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";

.PaymentMethodDeleteModal {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (max-width: 568px) {
    width: calc(100% - 10px);
  }

  &::-webkit-scrollbar {
    width: 8px;
    cursor: pointer;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: $GreySecondary;
    cursor: pointer;
  }
  &__warning {
    text-align: center;
    padding: 0 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/PaymentMethodDeleteModal.vue